import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* any functionality that's shared between component variants but not needed by external components goes in this file */
import React, { useEffect, useRef, useState } from 'react';
import { tabbingOutsideOfElement } from '@chegg-ui/utils';
export function usePopoverBehavior(targetElement, onPopoverStateChange, popoverPaneRef) {
  var _React$cloneElement;

  var targetElementRef = useRef(null);
  var wrapperRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPopoverShown = _useState2[0],
      setIsPopoverShown = _useState2[1];

  var togglePopover = function togglePopover() {
    if (isPopoverShown) {
      setIsPopoverShown(false);
    } else {
      setIsPopoverShown(true);
    }
  };

  var documentClickHandler = function documentClickHandler(e) {
    var _popoverPaneRef$curre;

    if (!(popoverPaneRef !== null && popoverPaneRef !== void 0 && (_popoverPaneRef$curre = popoverPaneRef.current) !== null && _popoverPaneRef$curre !== void 0 && _popoverPaneRef$curre.contains(e.target) || e.target === targetElementRef.current || targetElementRef.current && targetElementRef.current.contains(e.target))) {
      setIsPopoverShown(false);
    }
  };

  var documentKeydownHandler = function documentKeydownHandler(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      setIsPopoverShown(false);
    }

    if (wrapperRef.current && tabbingOutsideOfElement(e, wrapperRef.current)) {
      setIsPopoverShown(false);
    }
  };

  useEffect(function () {
    if (isPopoverShown) {
      // use capture instead of bubble here to prevent race condition leading to unintentional closing
      document.addEventListener('click', documentClickHandler, true);
      document.addEventListener('keydown', documentKeydownHandler, true);
    }

    onPopoverStateChange && onPopoverStateChange(isPopoverShown);
    return function () {
      document.removeEventListener('click', documentClickHandler, true);
      document.removeEventListener('keydown', documentKeydownHandler, true);
    };
  }, [isPopoverShown]);
  var givenOnClick = targetElement.props.onClick;
  var givenOnKeyDown = targetElement.props.onKeyDown;
  var extendedTargetElement = /*#__PURE__*/React.cloneElement(targetElement, (_React$cloneElement = {
    onClick: function onClick(e) {
      if (givenOnClick) {
        givenOnClick(e);
      }

      togglePopover();
    },
    onKeyDown: function onKeyDown(e) {
      if (givenOnKeyDown) {
        givenOnKeyDown(e);
      }

      if (e.key && e.key === 'Enter') {
        // This will trigger click if default behaviour is not prevented
        e.preventDefault();
        togglePopover();
      }
    },
    ref: targetElementRef
  }, _defineProperty(_React$cloneElement, 'aria-haspopup', true), _defineProperty(_React$cloneElement, 'aria-expanded', isPopoverShown), _React$cloneElement));
  return {
    isPopoverShown: isPopoverShown,
    extendedTargetElement: extendedTargetElement,
    wrapperRef: wrapperRef
  };
}